const adminPanel = {
  adminPanel: {
    einAdmin: 'EIN Admin',
    einInstallerSetup: 'EIN-installatie',
    installerDataUpdate: 'Update van de installatiegegevens',
    uploadFile: 'Bestand uploaden',
    chooseFile: 'Kies Bestand',
    installerDataUpdateDescription: 'Enphase Installateur marktaandeel, executive sponsor informatie etc.',
    header: 'Header van de links in de balk',
    platinumTier: 'Platinatrap',
    goldTier: 'Gouden niveau',
    silverTier: 'Zilver niveau',
    same: 'Hetzelfde voor alle niveaus',
    bannerDescription: 'Banner-Beschrijving',
    bannerLink: 'Banner-Link',
    digitalAssets: 'Digitale middelen',
    name: 'Naam',
    file: 'Bestand',
    access: 'Toegang tot Niveau Categorie',
    action: 'Actie',
    all: 'Allemaal',
    platinum: 'Platina',
    gold: 'Goud',
    silver: 'Zilver',
    addDigital: 'Digitale middelen toevoegen',
    productInformation: 'Productinformatie',
    productName: 'Productnaam',
    learnMoreLink: 'Link naar meer informatie ',
    featureName: 'A/B-kenmerknaam',
    featureType: 'Eigenschapstype',
    betaRelease: 'Beta-uitgiftedatum',
    addProduct: 'Productinformatie toevoegen',
    exclusiveUpdate: 'Exclusieve update-links',
    description: 'Beschrijving',
    link: 'Link',
    addLink: 'Link toevoegen',
    one: '1.',
    two: '2.',
    installerList: 'Installateurslijst voor producttoegang',
    usa: 'VS',
    // TODO - Start
    usa_pr: 'USA - Puerto Rico',
    france: 'France',
    // TODO - End
    australia: 'Australië',
    belgium: 'België',
    netherlands: 'Nederland',
    germany: 'Duitsland',
    india: 'India',
    mexico: 'Mexico',
    country: 'Land',
    fileName: 'Bestandsnaam',
    software_service: 'SOFTWARE_SERVICE',
    hardware_product: 'HARDWARE_PRODUCT',
    empty_file: 'Bestand is leeg',
    invalidFileFormat: 'Ongeldig bestandsformaat',
    invalidFileHeader: 'Ongeldige bestandskop',
    uploadFailed: 'Geen bestand geüpload',
    invalidFile: 'Ongeldig bestand',
    errorDetail: {
      one: '%{errorCount} van de %{telling} rij(en) is mislukt.',
      other: '%{errorCount} van de %{telling} rij(en) is mislukt.'
    },
    viewError: 'Bekijk Fouten',
    errorListText: 'Foutenlijst voor het uploaden van bestanden',
    companyId: 'Bedrijfs-ID',
    message: 'Bericht',
    sampleFileName: 'Voorbeeldbestand'
  }
};

export default adminPanel;
